import React from "react";
import { Link } from "react-router-dom";
import {
  BarChart3,
  CircleHelp,
  ClipboardList,
  LayoutDashboard,
  Mail,
  MessageSquareText,
  School,
  Settings,
  X,
} from "lucide-react";
import brandLogo from "../../assets/images/MySchoolMate.png";

const mainItems = [
  { label: "Overview", to: "/dashboard/sekolah", icon: LayoutDashboard, exact: true },
  { label: "Data Sekolah", to: "/dashboard/sekolah/data", icon: School },
  { label: "Pendaftaran", to: "/dashboard/sekolah/pendaftaran", icon: ClipboardList },
  { label: "Statistik", to: "/dashboard/sekolah/statistik", icon: BarChart3 },
  { label: "Review & Testimoni", to: "/dashboard/sekolah/review", icon: MessageSquareText },
  { label: "Pesan Masuk", to: "/dashboard/sekolah/pesan", icon: Mail },
];

const accountItems = [
  { label: "Pengaturan", to: "/dashboard/sekolah/pengaturan", icon: Settings },
  { label: "Bantuan", to: "/dashboard/sekolah/bantuan", icon: CircleHelp },
];

function NavGroup({ label, items, pathname, onClose }) {
  return (
    <div className="mb-6">
      <p className="mb-2 px-3 text-[10px] font-extrabold uppercase tracking-[0.18em] text-ink/35">{label}</p>
      <ul className="space-y-1.5">
        {items.map((item) => {
          const active = item.exact ? pathname === item.to : pathname.startsWith(item.to);
          const Icon = item.icon;
          return (
            <li key={item.label}>
              <Link
                to={item.to}
                onClick={onClose}
                aria-current={active ? "page" : undefined}
                className={`relative flex min-h-11 items-center gap-3 rounded-[14px] px-3.5 text-sm font-bold transition-colors focus-ring ${
                  active ? "bg-[#FFF3D7] text-ink" : "text-ink/62 hover:bg-cream hover:text-ink"
                }`}
              >
                {active ? <span className="absolute left-0 h-6 w-1 rounded-r-full bg-[#F7AB2D]" aria-hidden="true" /> : null}
                <Icon className={`h-[18px] w-[18px] ${active ? "text-[#C47B00]" : "text-ink/50"}`} aria-hidden="true" />
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default function SchoolDashboardSidebar({ pathname, open, onClose, schoolName, representativeName }) {
  return (
    <>
      {open ? (
        <button type="button" className="fixed inset-0 z-40 bg-ink/25 lg:hidden" aria-label="Tutup menu dashboard" onClick={onClose} />
      ) : null}

      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-[250px] flex-col border-r border-ink/10 bg-white px-4 py-5 transition-transform duration-200 lg:sticky lg:top-0 lg:h-screen lg:translate-x-0 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
        aria-label="Navigasi dashboard perwakilan sekolah"
      >
        <div className="flex items-center justify-between gap-3 px-2">
          <Link to="/" className="rounded-lg focus-ring" aria-label="Kembali ke beranda MySchoolMate">
            <img src={brandLogo} alt="MySchoolMate" width="288" height="43" className="h-8 w-auto" />
          </Link>
          <button type="button" onClick={onClose} className="flex h-10 w-10 items-center justify-center rounded-xl text-ink hover:bg-cream focus-ring lg:hidden" aria-label="Tutup menu">
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>

        <nav className="mt-8 flex-1 overflow-y-auto" aria-label="Menu dashboard sekolah">
          <NavGroup label="Utama" items={mainItems} pathname={pathname} onClose={onClose} />
          <NavGroup label="Akun" items={accountItems} pathname={pathname} onClose={onClose} />
        </nav>

        <div className="mt-4 border-t border-ink/10 pt-5">
          <div className="rounded-[16px] bg-warm p-3">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[13px] bg-[#FFF3D7] text-[#B46F00]">
                <School className="h-5 w-5" aria-hidden="true" />
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-extrabold text-ink">{schoolName || "Sekolah belum diatur"}</p>
                <p className="truncate text-xs font-bold text-ink/55">{representativeName || "Pengguna"}</p>
              </div>
            </div>
            <p className="mt-2 pl-[52px] text-[11px] font-medium text-ink/45">Perwakilan Sekolah</p>
          </div>
        </div>
      </aside>
    </>
  );
}
